import React, { Component } from 'react'
import {Actions} from 'jumpstate'
import {TransitionGroup, CSSTransition} from 'react-transition-group'

import './BackgroundSlider.css'

class BackgroundSlider extends Component {
  constructor (props) {
    super(props)

    this.state = {
      input: [],
      showTime: 8000,
      activeSlide: 0
    }
    this.tick = this.tick.bind(this)
  }

  tick () {
    this.setState({activeSlide: (this.state.activeSlide + 1) % this.state.input.length})
  }

  componentWillMount () {
    Actions.sliderList().then((res) => {
      let result = []
      res.data.map((item) => result.push(item.path))
      this.setState({input: result})
    })
  }

  componentDidMount () {
    this.interval = setInterval(this.tick, this.state.showTime)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  render () {
    const { input, activeSlide } = this.state

    return (
      <ul className="cb-slideshow">
        <TransitionGroup enter appear exit>
          {input.map((item, i) => {
            if (i === activeSlide) {
              return <CSSTransition key={activeSlide} classNames="fade" timeout={4000}><li><span style={{backgroundImage: `url(${item})`}} /></li></CSSTransition>
            }
            return undefined
          })}
        </TransitionGroup>
      </ul>
    )
  }
}

export default BackgroundSlider



// WEBPACK FOOTER //
// ./src/components/Common/BackgroundSlider/BackgroundSlider.js